import { TSegmentedControlOption } from "@/components/elements/SegmentedControl";
import { EContractStatus } from "@/types/enum";

export const CONTRACT_FILTER_OPTIONS: TSegmentedControlOption[] = [
  { label: "契約中", value: EContractStatus.DURING_CONTRACT },
  { label: "トライアル中", value: EContractStatus.TRIAL },
  { label: "すべて表示", value: "" },
];
